import CategoryChart from './CategoryChart.jsx'

export default CategoryChart
